import React, {useEffect, useRef, useState} from 'react';
import {View, StyleSheet, Dimensions, Text, findNodeHandle} from 'react-native';
//import {WebView} from 'react-native-webview';
import CCText from '@/Atoms/CCText';
import {embedDashboard} from '@superset-ui/embedded-sdk';
import {getAccessToken, getGuestToken} from '../../utils/AccessToken';
import ENV from '../../../../../environment';
import Spacer from '@/Atoms/Spacer';
import Loader from '@/Atoms/CCLoader/CCLoader';
import CCColors from '@/Utils/CCColors';
import {useRoute} from '@react-navigation/native';

const {SUPERSET_URL, SUPERSET_USERNAME, SUPERSET_PASSWORD} = ENV;

const supersetUrl = SUPERSET_URL || 'http://localhost:8088';

interface SupersetReportProps {
  dashboardId: string;
  userData: {[key: string]: string};
}

const SupersetReport: React.FC<SupersetReportProps> = ({
  dashboardId,
  userData,
}) => {
  const [isDashboardError, setIsDashboardError] = useState(false);
  const viewRef = useRef<View>(null);
  const route = useRoute();
  const user_id = route.params?.user_id || '';
  const user_key = route.params?.user_key || '';
  console.log(user_id, 'user_id');

  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        setIsDashboardError(false);

        const accessToken = await getAccessToken();
        const guestToken = await getGuestToken(accessToken, dashboardId);
        const mountPoint = findNodeHandle(viewRef.current);

        // console.log(
        //   'Access Token and Guest Token generated',
        //   accessToken,
        //   guestToken,
        // );

        embedDashboard({
          id: dashboardId,
          supersetDomain: supersetUrl,
          mountPoint,
          fetchGuestToken: async () => guestToken,
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: true,
            hideTab: true,
            filters: {
              visible: true,
              expanded: false, //this
            },
            urlParams: {
              standalone: '0', //set it as 3 if you want to hide all the bars
              show_filters: '1', //this 0
              show_native_filters: '1', //this 0
              //genre: ['Sports', 'Puzzle'], //sample for multiple values
              user_id: user_id && user_key ? user_id : userData.user_id, //working properly👍
            },
          },
        });

        const iframe = document.querySelector('iframe');

        //console.log(iframe);
        if (iframe) {
          iframe.style.width = '100%';
          iframe.style.minHeight = '100vh';
        }
      } catch (error) {
        setIsDashboardError(true);
        console.error('Error initializing dashboard:', error);
      }
    };

    if (dashboardId) {
      initializeDashboard();
    }
  }, [dashboardId, userData, user_id]);

  return (
    <View style={styles.container}>
      {/* <View style={styles.webview}> */}
      {isDashboardError && (
        <View>
          <Spacer spacing={40} />
          <CCText> Dashboard is not available </CCText>
        </View>
      )}
      {!isDashboardError && <View style={styles.report} ref={viewRef} />}
      {/* </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
    width: '80%',
    height: '100%',
  },
  report: {
    flex: 1,
    width: '95%',
    height: '95%',
  },
});

export default SupersetReport;
